import api from 'services/api/microfwk';
import _ from 'lodash';
import { setProfileLastTouchFavorited } from 'utils/Socialization';

export const favoriteDel = (params = {}) => dispatch =>
  api
    .get('/services/user/favoritedel', {
      params,
    })
    .then(({ data }) => {
      if (data?.lasttouch?.favorited) {
        setProfileLastTouchFavorited(data.lasttouch.favorited);
      }
      return data;
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export const favoriteAdd = (params = {}) => dispatch =>
  api
    .get('/services/user/favoriteadd', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });

export const favorited = (params = {}) =>
  api
    .get('/services/user/favorited', {
      params,
    })
    .then(({ data }) => data)
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      return error;
    });
